import { lastVideoReducer } from './videoListing/lastVideo_reducer';

const reducers = {
  lastVideo: lastVideoReducer,
};
export default reducers;
